var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loader-wrapper',[_c('styled-spinner-svg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }